import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "antd";
import "./NotificationItem.css";
import moment from "moment";
import { getImage } from "../../../../utilities/storageOperations/downloadURL";
import enums from "../../../../components/Enum";
import history from "../../../../routes/history";
// import { fetchNotification, readNotification } from "../../redux/actions";
import { readNotification } from "../../../../redux/actions";
import { useDispatch } from "react-redux";
import { log } from "@antv/g2plot/lib/utils";
import PrivateGigsTagNodification from "../PrivateGigsTagNodification";

export default function NotificationItem(props) {
  const [imageUrl, setimageUrl] = useState("");
  const [notificationId, setNotificationId] = useState("");
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));

  const notificationCard = useRef();
  const dispatch = useDispatch();
  useEffect(() => {
    getPicture(props.img);
  }, []);

  function capitalizeFirstLetter(string) {
    return string?.charAt(0).toUpperCase() + string.slice(1);
  }

  // useEffect(() => {
  //   if (notificationId) {
  //   }
  // }, [notificationId]);

  const getPicture = (Key) => {
    var url = Key;
    if (url !== null) {
      // var key = imageURLSplit(url);
      setimageUrl(url);
      // getImage(url)
      //   .then((result) => {
      //   })
      //   .catch(() => {
      //   });
    } else {
    }
  };

  if (props?.item?.SourceTypeId == 100)
    return (
      <Row
        key={props.index}
        ref={notificationCard}
        style={{
          backgroundColor: props?.item?.Read === 1 ? "white" : "#f0f4ff",
        }}
        className="notificationItem"
        onClick={() => {
          setNotificationId(props.item.NotificationId);
          notificationCard.current.style.backgroundColor = "white";
          dispatch(readNotification(props?.item?.NotificationId));
          props.visible(false);
          history.push(`/profiledetail/${props?.item?.SkillListingId}`)
        }}
      >
        <Col span={6} className="imageCont">
          {userProfile?.EmployeeAssociation?.includes(
            props?.item?.senderprofile[0]?.AccountId
          ) && (
            <PrivateGigsTagNodification
              capitalizeFirstLetter={capitalizeFirstLetter}
              userProfile={userProfile}
            />
          )}
          <div>
            {imageUrl && imageUrl?.split("/")?.pop() !== "no-pic.png" ? (
              <img
                src={`${process.env.REACT_APP_S3_URL}${
                  imageUrl?.charAt(0) !== "/" ? "/" : ""
                }${imageUrl}`}
                alt={
                  userProfile?.Profiles?.FirstName
                    ? capitalizeFirstLetter(userProfile?.Profiles?.FirstName)
                    : userProfile?.UserName
                }
                className="noti-img"
              />
            ) : (
              <div className="image-notifi-container">
                <div className="image-notifi-text">
                  {props?.item?.senderprofile[0]?.Profiles?.CompanyName
                    ? props?.item?.senderprofile[0]?.Profiles?.CompanyName?.charAt(
                        0
                      ).toUpperCase()
                    : props?.item?.senderprofile[0]?.Profiles?.FirstName?.charAt(
                        0
                      ).toUpperCase() ??
                      props?.item?.senderprofile[0]?.UserName?.charAt(
                        0
                      ).toUpperCase()}
                </div>
              </div>
            )}
          </div>
        </Col>
        <Col span={18}>
          <div className="notificationTitle">
            <span>{props?.message}</span>
          </div>
          <div className="notificationTime">
            {moment(props.created).fromNow()}
          </div>
        </Col>
      </Row>
    );

  return (
    <Row
      key={props.index}
      ref={notificationCard}
      style={{ backgroundColor: props?.item?.Read === 1 ? "white" : "#f0f4ff" }}
      className="notificationItem"
      onClick={() => {
        setNotificationId(props.item.NotificationId);
        notificationCard.current.style.backgroundColor = "white";
        dispatch(readNotification(props?.item?.NotificationId));
        if (props.item?.Message === "First Gig Created") {
          history.push({
            pathname: `/joblisting`,
            state: {
              id: props.item?.SourceId,
            },
          });
        } else if (props.item?.Message === "JR Gig Created" || props.item?.Message === "JR Gig Closed") {
          history.push({
            pathname: `/jobdetail/${props.item?.SourceId}`,
            state: {
              id: props.item?.SourceId
            }
          });
        } else if (props.item?.Message === "Profile Updated") {
          history.push({
            pathname: `/companyprofile/companydetails`,
          });
        } else if (props.item?.Message === "Moved to Rating"){
          history.push({
            pathname: "/ratings",
            state: {
              bidId: props.item?.SecondarySourceId, //before bid id was here
              image: props?.item?.senderprofile[0]?.Profiles?.PictureUrl,
              candidate_name: props?.item?.senderprofile[0]?.Profiles?.FirstName +
              " " +
              props?.item?.senderprofile[0]?.Profiles?.LastName,
              Reviewee: props?.item?.senderprofile[0]?.AccountId, //recipientUser?.AccountId
              job_title: props.item?.SourceName,
              previousScreen: "Notifications",
              conversationId: props?.item?.conversationId,
              SourceTypeId: props?.item?.SourceTypeId
              // Reviewee:
              //   chatDetails?.data?.body[0]?.SourceTypeId == 1
              //     ? chatDetails?.data?.body[0]?.RecipientUser?.AccountId
              //     : chatDetails?.data?.body[0]?.SenderUser?.AccountId,
              // SourceTypeId: chatDetails?.data?.body[0]?.SourceTypeId,
            },
          });
        }
         else {
          if(history.location.pathname.includes("conversations")){
            history.replace({
              pathname: `/conversations/${props.item.conversationId ? props.item.conversationId : props.item.ConversationId}`,
              state: {
                openConvo: true,
                conversationId: props.item.conversationId ? props.item.conversationId : props.item.ConversationId,
                notification: true,
              },
            });
          }else{
            history.push({
              pathname: `/conversations/${props.item.conversationId ? props.item.conversationId : props.item.ConversationId}`,
              state: {
                openConvo: true,
                conversationId: props.item.conversationId ? props.item.conversationId : props.item.ConversationId,
                notification: true,
              },
            });
          }

        }
        props.visible(false);
      }}
    >
      <Col span={6} className="imageCont">
        {userProfile?.EmployeeAssociation?.includes(props?.item?.senderprofile[0]?.AccountId) && <PrivateGigsTagNodification
          capitalizeFirstLetter={capitalizeFirstLetter}
          userProfile={userProfile}
        />}
        <div>
          {imageUrl && imageUrl?.split("/")?.pop() !== "no-pic.png" ? (
            <img
              // src={imageUrl}
              src={`${process.env.REACT_APP_S3_URL}${
                imageUrl?.charAt(0) !== "/" ? "/" : ""
              }${imageUrl}`}
              alt={
                userProfile?.Profiles?.FirstName
                  ? capitalizeFirstLetter(userProfile?.Profiles?.FirstName)
                  : userProfile?.UserName
              }
              className="noti-img"
            />
          ) : (
            <div className="image-notifi-container">
              <div className="image-notifi-text">
                {
                  props?.item?.senderprofile[0]?.Profiles?.CompanyName
                  ? props?.item?.senderprofile[0]?.Profiles?.CompanyName
                      ?.charAt(0)
                      .toUpperCase()
                  : props?.item?.senderprofile[0]?.Profiles?.FirstName?.charAt(0).toUpperCase()??props?.item?.senderprofile[0]?.UserName?.charAt(0).toUpperCase()}
              </div>
            </div>
          )}
        </div>
      </Col>
      <Col span={18}>
        {/* SourceTypeName === 'GigListing' */}
        <div className="notificationTitle">
          <span>
            {
            // props?.message == "Bid is placed" ||
            props?.message == "Profile is submitted" ||
            props?.message == "Offer is made" ||
            props?.message == "Candidate is hired" ||
            props?.message == "bid placed notify employer" ||
            props?.message == "Offer is accepted" ||
            props?.message == "Candidate is rejected"
              ? enums[props?.message]
                ?  props.item?.SenderProfileId !== userProfile.AccountId ?
                enums[props?.message] +`${props?.item?.senderprofile[0]?.Profiles?.FirstName +" " +
                props?.item?.senderprofile[0]?.Profiles?.LastName} ${(props?.item?.SourceName ? "for gig " + props?.item?.SourceName : "")} `
                  
                : enums[props?.message] + props?.item?.senderprofile[0]?.Profiles?.FirstName +
                " " +
                props?.item?.senderprofile[0]?.Profiles?.LastName
                : ` You've got a new message from ${props?.item?.senderprofile[0]?.Profiles?.FirstName}` 
              : // : props?.message == "Interview is scheduled" ? props?.item?.senderprofile[0]?.Profiles?.CompanyName + enums[props?.message] ? enums[props?.message] : " You've got a new message from "
              // : props?.message == "Interview is rescheduled" ? enums[props?.message] ?  props?.item?.senderprofile[0]?.Profiles?.FirstName+" "+props?.item?.senderprofile[0]?.Profiles?.LastName + enums[props?.message] : " You've got a new message from "
              props?.message == "Candidate is moved to on billing"
              ? enums[props?.message]
                ? enums[props?.message] +
                  props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName +
                  " has offically started "
                : " You've got a new message from "
                : props?.message == "Interview is accepted"
                ? enums[props?.message]
                  ? enums[props?.message] +
                    props?.item?.senderprofile[0]?.Profiles?.FirstName +
                    " " +
                    props?.item?.senderprofile[0]?.Profiles?.LastName +
                    ( props?.item?.SourceName ? 
                    " for " + props?.item?.SourceName : "" )
                  : " You've got a new message from "
              : props?.message == "Interview is canceled"
                ? enums[props?.message]
                  ?props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName +
                   enums[props?.message] + (props?.item?.SourceName ? "for the " + props?.item?.SourceName : "")
                  : " You've got a new message from "
            : props?.message == "Interview is rescheduled"
                ? enums[props?.message]
                  ?props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName +
                   enums[props?.message] +
                    " " + (props?.item?.SourceName ? "for " + props?.item?.SourceName : " ")
                  : " You've got a new message from "
          : props?.message == "Bid is placed"
                ? enums[props?.message]
                  ? enums[props?.message] + " " + props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName
                  + " is interested in your " + (props?.item?.SourceName ? props?.item?.SourceName : " gig")
                  : " You've got a new message from "
              : props?.message == "bid retracted by employer"
              ? enums[props?.message]
                ? enums[props?.message] +
                  props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName +
                  " canceled their bid on your listing "
                : " You've got a new message from "
              : props?.message == "Moved to Rating"
                ? enums[props?.message]
                  ? props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName + enums[props?.message] + ( props?.item?.SourceName ? props?.item?.SourceName : "" ) + "! Give them a 5-star rating" 
                    : " You've got a new message from "
              : props?.message == "Job is completed"
              ? enums[props?.message]
                ? enums[props?.message] +
                  props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName +
                  " has ended "
                : " You've got a new message from "
                : props?.message == "Bid is accepted"
                ? enums[props?.message]
                  ? enums[props?.message] + ( props?.item?.SourceName ? "for "+ props?.item?.SourceName : "" ) + " " + " was accepted by " +
                    props?.item?.senderprofile[0]?.Profiles?.FirstName +
                    " " +
                    props?.item?.senderprofile[0]?.Profiles?.LastName
                    : " You've got a new message from "
                : props?.message == "Your bid has been retracted"
                ? enums[props?.message]
                  ? enums[props?.message] + props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName + " retracted their proposal" + ( props?.item?.SourceName ? " for "+ props?.item?.SourceName : "" ) 
                    : " You've got a new message from " 
                : props?.message == "Bid is declined"
              ? enums[props?.message]
                ? "Alert: " + props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName + enums[props?.message] +
                  (props?.item?.SourceName ? " for " + props?.item?.SourceName : "")
                : " You've got a new message from "
              : props?.message == "Moved to Rating"
                ? enums[props?.message]
                  ? props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName + enums[props?.message] + ( props?.item?.SourceName ? props?.item?.SourceName : "" ) + "! Give them a 5-star rating" 
                    : " You've got a new message from "
              : props?.message == "Rating is created"
                ? enums[props?.message]
                  ? enums[props?.message] + props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName  + ( props?.item?.SourceName ? " for the gig " + props?.item?.SourceName : "" ) + "!" 
                    : " You've got a new message from "
              : props?.message == "JR Gig Created"
                ? enums[props?.message]
                  ? enums[props?.message] +
                    (props?.item?.SourceName ? props?.item?.SourceName : "") + ` has been created by ${props?.item?.senderprofile[0]?.Profiles?.CompanyName}`
                  : " You've created a new gig " 
              : props?.message == "JR Gig Closed"
                ? enums[props?.message]
                  ? enums[props?.message] +
                    (props?.item?.SourceName ? props?.item?.SourceName : "") + ` of this ${props?.item?.senderprofile[0]?.Profiles?.CompanyName} has expired ${props?.item?.SourceOfferDate ? "on " + moment(props?.item?.SourceOfferDate).format('MM/DD/YYYY')  : ""}`
                  : " You've created a new gig " 
                : props?.message == "First Gig Created"
                ? enums[props?.message]
                  ? enums[props?.message] +
                    (props?.item?.SourceName ? props?.item?.SourceName : "")
                  : " You've created a new gig " 
                  : props?.message == "Interview is proposed" ||
                props?.message == "Interview is scheduled"
              ? enums[props?.message]
                ? enums[props?.message] +
                  props?.item?.senderprofile[0]?.Profiles?.FirstName +
                  " " +
                  props?.item?.senderprofile[0]?.Profiles?.LastName +
                  " sent you an interview request! "
                : " You've got a new message from "
              : enums[props?.message]
              ? enums[props?.message]
              : props?.item?.SourceName ? " You've got a new message from " +
              props?.item?.senderprofile[0]?.Profiles?.FirstName +
              " " +
              props?.item?.senderprofile[0]?.Profiles?.LastName + " for " + props?.item?.SourceName :  " You've got a new message from " +
                props?.item?.senderprofile[0]?.Profiles?.FirstName +
                " " +
                props?.item?.senderprofile[0]?.Profiles?.LastName}
          </span>
        </div>

        {props.type === "Interview" ? (
          <>
            <div className="interviewerName">
              Interview with {props.interviewer}
            </div>
            <div className="interviewTime">
              {moment(props.scheduleTimings).endOf("day").fromNow()}{" "}
              {moment(props.startTime).format("HH:MM A")} -{" "}
              {moment(props.endTime).format("HH:MM A")}
            </div>
            <div className="attendInterview">Attend Interview</div>
          </>
        ) : null}
        <div className="notificationTime">
          {moment(props.created).fromNow()}
        </div>
      </Col>
    </Row>
  );
}
